import { NavLink, Outlet, useNavigate } from 'react-router-dom'

import { isStaff, useAuth } from '../lib/auth.tsx'

export function Layout(): React.JSX.Element {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  const staff = isStaff(user)

  const handleLogout = async (): Promise<void> => {
    await logout()
    void navigate('/login', { replace: true })
  }

  return (
    <div className="app">
      <header className="topbar">
        <NavLink to="/" className="topbar__brand">
          Senses <span>trénink</span>
        </NavLink>

        <nav className="topbar__nav">
          <NavItem to="/" label={staff ? 'Přehled' : 'Můj trénink'} end />
          {staff && <NavItem to="/klienti" label="Klienti" />}
          {staff && <NavItem to="/programy" label="Programy" />}
          {staff && <NavItem to="/trenink" label="Vyzkoušet hru" />}
          {user?.role === 'admin' && <NavItem to="/uzivatele" label="Uživatelé" />}
        </nav>

        <div className="topbar__user">
          <span className="topbar__name">
            {user?.name}
            {staff && <span className="dim"> · {user?.role === 'admin' ? 'admin' : 'trenér'}</span>}
          </span>
          <NavLink to="/nastaveni" className="btn btn--ghost btn--sm">
            Nastavení
          </NavLink>
          <button type="button" className="btn btn--sm" onClick={() => void handleLogout()}>
            Odhlásit
          </button>
        </div>
      </header>

      <Outlet />
    </div>
  )
}

function NavItem({ to, label, end }: { to: string; label: string; end?: boolean }): React.JSX.Element {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) => `topbar__link ${isActive ? 'topbar__link--active' : ''}`}
    >
      {label}
    </NavLink>
  )
}
